module.exports = __webpack_public_path__ + "img/data_arranging_outline.92725e14.svg";